import { useCallback, useState } from 'react'
import type { ProductionRequestLineRecord } from '../types/records'

export type PostToWorkTarget = {
  lineId: string
  productId: string
  productName: string
  quantity: number
  lineStatus?: ProductionRequestLineRecord['status']
}

export function usePostToWorkModal() {
  const [target, setTarget] = useState<PostToWorkTarget | null>(null)

  const open = useCallback((next: PostToWorkTarget) => {
    setTarget(next)
  }, [])

  const close = useCallback(() => {
    setTarget(null)
  }, [])

  return {
    target,
    isOpen: target != null,
    open,
    close,
  }
}
